import { createTheme } from "@mui/material";
import { deepOrange } from "@mui/material/colors";

const theme = createTheme({
    palette: {
        primary: {
            main: "#05668d"
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                variant: "outlined",
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: "20px"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                variant:"outlined"
            }
        }
    }
});

export default theme;